import React, { useState } from "react";
import { PythonDevFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const PythonDeveloper = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };

  return (<>
    <Helmet>
      <meta name="description" content="Hire expert Python developers in India to build powerful, scalable, and secure web or AI-based applications. Get cost-effective Python development for your business growth."/>
<meta name="copyright" content="codeglim"/>
<meta property="og:title" content="Hire Expert Python Developers in India | Ayanshtech Solutions"/>
<meta property="og:site_name" content="Ayanshtech Solutions"/>
<meta property="og:url" content="https://ayanshtechnology.com/hire-python-developers"/>
<meta property="og:description" content="Hire expert Python developers in India to build powerful, scalable, and secure web or AI-based applications. Get cost-effective Python development for your business growth."/>
<meta property="og:type" content="website"/>
<meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<meta name="twitter:card" content="summary"/>
<meta name="twitter:site" content="@Ayanshtech Solutions"/>
<meta name="twitter:title" content="Hire Expert Python Developers in India | Ayanshtech Solutions"/>
<meta name="twitter:description" content="Hire expert Python developers in India to build powerful, scalable, and secure web or AI-based applications. Get cost-effective Python development for your business growth."/>
<meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<link rel="canonical" href="https://ayanshtechnology.com/hire-python-developers"/>
<title>Hire Expert Python Developers in India | Ayanshtech Solutions</title>
    </Helmet>
    <div className="flex flex-col items-center justify-center p-6">
      <div className=" p-4 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
          <div className="lg:w-3/4  lg:text-left">
            <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Hire Expert Python Developers in India
            </h1>
            <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
              Python is a versatile and powerful programming language, ideal for
              building scalable web applications, automating tasks, and
              developing data-driven solutions. Whether you're looking to create
              a backend system, develop machine learning models, or implement
              custom automation scripts, our expert Python developers are here
              to deliver high-quality, efficient solutions tailored to your
              needs.
              <br />
              <br />
              Leverage the full potential of Python for your business. Hire our
              skilled Python developers at Ayanshtech and unlock innovative
              solutions to elevate your project.
            </p>
            <p className="  text-gray-600 sm:text-lg md:text-xl lg:text-xl">
              Starting from just <span className="font-bold">US $15/hour</span>
            </p>
            <button
              onClick={scrollToContact}
              className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-6"
            >
              Hire a Python Developer
            </button>
          </div>

          <div className="flex justify-center mb-12 lg:mb-0 mt-5">
            <img
              src="\assets\images\headerSection\hirePythonDev\img1.webp"
              alt="Python Solutions for Businesses"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-20">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Expertise of Our Python Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Our team of Python developers at Ayanshtech leverages cutting-edge
          technologies to deliver high-quality applications. Hire Python experts
          who are proficient in utilizing powerful tools to build scalable and
          efficient solutions.
        </p>
      </div>

      <div className=" p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon6.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Bottle: Perfect for small web applications
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon7.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Pyramid: Ideal for developing straightforward web apps
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon8.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Web2py: Features a built-in ticketing system
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon9.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Django: For building sophisticated and complex web applications
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon10.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Django: Best suited for writing complex and advanced code
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon11.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              CherryPy: Runs efficiently on a multi-threaded server
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon12.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Falcon: Enables the creation of clean and optimized designs
            </p>
          </div>
        </div>
      </div>

      <div className="text-center  mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Experienced Python Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Hire expert Python developers who can meet your project needs at
          affordable rates.
        </p>
      </div>

      <div className="">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/3 p-4">
            <img
              src="\assets\images\headerSection\hirePythonDev\img2.png"
              alt="Laptop with graph"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon13.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Expertise in web scraping and automation through efficient
                  scripting.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon14.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Proficient in developing image-based applications with
                  advanced knowledge.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon15.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Skilled in building audio and video-based applications with
                  precision.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon16.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Extensive experience with web frameworks such as Django,
                  Flask, and CherryPy.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon17.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Familiarity with version control systems like Git, Mercurial,
                  and SVN.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon18.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Expertise in front-end technologies including HTML5,
                  JavaScript, and CSS3.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AyanshtechAdvantage />

      <div className="max-w-3xl mx-auto p-6 mt-10 w-full ">
        <h2 className="sm:text-4xl md:text-5xl lg:text-6xl font-bold text-center ">
          FAQs
        </h2>
        {PythonDevFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index
                  ? "bg-blue-600 text-white px-5 rounded-2xl"
                  : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

      <div id="contact-section">
        {" "}
        <Contact />
      </div>

      <GetInTouch />
    </div>
  </>);
};

export default PythonDeveloper;
